import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";

export const Container = styled.main`
  padding: 1rem;

  label,
  input {
    display: block;
  }

  label {
    margin-bottom: 0.5rem;
    margin-left: 0.25rem;
  }

  label > input {
    margin-top: 0.25rem;
  }
`;

export const Form = styled.form`
  max-width: 400px;
  margin: 0 auto;
`;

export const FormActions = styled.footer`
  margin-top: 2rem;
`;
export const ErrorText = styled.div`
  color: #f40012;
  margin: 0px 0px 20px 0px;
  text-align: center;
  font-weight: bold;
`;

export const Spacer = styled.div`
  margin-top: 150px;
`;

export const ButtonActions = styled.footer`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 20px;
  white-space: nowrap;
  margin: 20px auto;
`;

export const Link = styled(RouterLink)`
  color: #000;
  margin-top: 3rem;
  text-align: center;
  display: block;
`;
